import { render, staticRenderFns } from "./periodePenggajian.vue?vue&type=template&id=c4e1623c"
import script from "./periodePenggajian.vue?vue&type=script&lang=js"
export * from "./periodePenggajian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports